import { AsyncPipe } from '@angular/common';
import { Component, DestroyRef, OnInit } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { RevealDetailsService } from '@app/shared/components/reveal-details/reveal-details.service';
import { Observable } from 'rxjs';

@Component({
  selector: 'portal-reveal-details',
  standalone: true,
  imports: [AsyncPipe],
  templateUrl: './reveal-details.component.html',
  styles: ``,
})
export class RevealDetailsComponent implements OnInit {
  visible$: Observable<boolean>;

  constructor(
    private destroyRef: DestroyRef,
    private revealDetailsService: RevealDetailsService
  ) {}

  ngOnInit(): void {
    this.visible$ = this.revealDetailsService.visible$.pipe(takeUntilDestroyed(this.destroyRef));
  }
}
